import { create } from "zustand";
import { api } from "@/lib/api";

export interface Label {
  id: string;
  name: string;
  color: string;
}
interface LabelState {
  labels: Label[];
  loaded: boolean;
  load: () => Promise<void>;
  create: (name: string) => Promise<Label>;
  rename: (id: string, name: string) => Promise<void>;
  remove: (id: string) => Promise<void>;
}
export const useLabels = create<LabelState>((set, get) => ({
  labels: [],
  loaded: false,
  load: async () => set({ labels: await api<Label[]>("/api/labels"), loaded: true }),
  create: async (name) => {
    const l = await api<Label>("/api/labels", { method: "POST", json: { name } });
    if (!get().labels.some((x) => x.id === l.id))
      set({ labels: [...get().labels, l].sort((a, b) => a.name.localeCompare(b.name)) });
    return l;
  },
  rename: async (id, name) => {
    await api(`/api/labels/${id}`, { method: "PATCH", json: { name } });
    set({ labels: get().labels.map((l) => (l.id === id ? { ...l, name } : l)) });
  },
  remove: async (id) => {
    await api(`/api/labels/${id}`, { method: "DELETE" });
    set({ labels: get().labels.filter((l) => l.id !== id) });
  },
}));
